import React from "react";
import useFetch from "@/lib/useFetch";
import { GlassCard, PageTitle, ProgressBar } from "@/components/lux";
import { money } from "@/lib/api";
import { Trophy, Check, Lock } from "lucide-react";

export default function Rewards() {
  const { data, loading } = useFetch("/user/rewards");
  if (loading || !data) return <><PageTitle title="Rewards" /><div className="skeleton h-40" /></>;
  const achieved = new Set(data.achievements.map((a) => a.target));
  return (
    <div className="space-y-6">
      <PageTitle title="Rewards & Recognition" subtitle="Milestone instant rewards for matched-business targets" />
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {data.targets.map((t) => {
          const done = achieved.has(t.target);
          return (
            <div key={t.target} className="relative overflow-hidden rounded-2xl p-6 transition-transform hover:-translate-y-1" data-testid={`reward-${t.target}`}
              style={{ background: done ? "linear-gradient(160deg,#C99A12,#6e5200)" : "linear-gradient(160deg,#0f1613,#0a0f0c)", border: "1px solid rgba(34,197,94,0.4)", boxShadow: "0 16px 36px -14px rgba(0,0,0,0.6)" }}>
              <div className="flex items-center justify-between">
                <div className="grid h-11 w-11 place-items-center rounded-xl bg-black/25 text-[var(--gold)]">
                  {done ? <Check size={20} className="text-white" /> : <Lock size={18} />}
                </div>
                <Trophy size={18} className="text-[var(--gold)]" />
              </div>
              <p className="mt-4 text-sm text-white/75">${money(t.target, 0)} matched business</p>
              <p className="mt-1 font-display text-2xl font-extrabold text-white">${money(t.instant, 0)}</p>
              <p className="mt-2 text-xs text-white/65">{done ? "✓ Reward credited" : "Locked — reach this target"}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
}
